import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { DemographicAgeGroup } from '@/core/api/entities/demographicAgeGroup'
import { DemographicAgeGroupMapper } from '@/core/api/mappers/demographicAgeGroupMapper'
import demographicAgeGroupService from '@/core/api/services/demographicAgeGroupService'

export const useDemographicAgeGroups = ({
	config,
	options,
}: any = {}): UseQueryResult<DemographicAgeGroup[], Error> => {
	const QUERY_KEY = [
		'demographic_age_groups',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			demographicAgeGroupService
				.getDemographicAgeGroups(config)
				.then(({ data }) => {
					return DemographicAgeGroupMapper.toEntities(data.data)
				}),
		...options,
		cacheTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
		staleTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
	})
}
